module.exports = __webpack_public_path__ + "static/media/cecelia-logo-black-bg.05bda05b.png";